import React, { FunctionComponent } from 'react';
import CloseButton from './CloseButton';

interface Props {
    title: string;
    children: any;
}

const Toast: FunctionComponent<Props> = ({ title, children }) => {

    return (
        <React.Fragment>
            <span className={'toast__title'}>
                { title }
            </span>

            <span className={'toast__desc'}>
                { children }
            </span>

            <div className={'toast__button-container'}>
                <CloseButton onClick={() => null} grey/>
            </div>
        </React.Fragment>
    );
};

export default Toast;
